import { render, staticRenderFns } from "./card-image-url.vue?vue&type=template&id=2f393f84&scoped=true"
import script from "./card-image-url.vue?vue&type=script&lang=js"
export * from "./card-image-url.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f393f84",
  null
  
)

export default component.exports